module.exports = __webpack_public_path__ + "img/MMI-logo.a2dcea7b.png";